export const ErrorCode = {
  MUST_BE_BETWEEN_MIN_MAX: 10110022,
  LESS_THAN_OR_EQUAL_TO: 10110009,
  PAYEE_CHALLENGE_CODE: 30310004,
  REGEX: 10110019,
  REDEMPTION_CODE_NOT_FOUND: 53810024,
};
